import type { FC } from "react";
import React from "react";

import { Button } from "@react/ui-primitives/button";

import type { OAuthClient, OAuthRequest } from "@apis/account/models";

interface ConsentPromptProps {
  readonly client: OAuthClient;
  readonly isPending: boolean;
  readonly onApprove: () => void;
  readonly onDeny: () => void;
  readonly request: OAuthRequest;
}

export const ConsentPrompt: FC<ConsentPromptProps> = ({
  client,
  isPending,
  onApprove,
  onDeny,
  request,
}) => {
  const resourceHost = new URL(request.resource).host;

  const redirectHost = new URL(request.redirectUri).host;

  const scopeClause =
    request.scopes.length > 0
      ? ` through the ${request.scopes.join(", ")} scope(s),`
      : "";

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">
        {client.clientName} asks to read and write your data on {resourceHost},
        {scopeClause} and returns you to {redirectHost} once you decide.
      </p>
      <p className="text-sm text-muted-foreground">
        The name above is the one this client registered itself under. Authorize
        it only when you recognize both that name and {redirectHost}.
      </p>
      <div className="flex gap-2">
        <Button disabled={isPending} onClick={onApprove}>
          Authorize
        </Button>
        <Button disabled={isPending} onClick={onDeny} variant="outline">
          Deny
        </Button>
      </div>
    </div>
  );
};
